import { render, staticRenderFns } from "./ThgQuote.vue?vue&type=template&id=e4706936&"
import script from "./ThgQuote.vue?vue&type=script&lang=ts&"
export * from "./ThgQuote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports